import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import WaterLocationTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import WaterLocationalEquipmentContents from "../WaterEquipment/WaterLocational";
import waterFoundIcon from "../../../../../assets/design-revamp-company/category-icons/water_found_icon.svg";
const WaterFoundLocationContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("WATER_FOUND_LOCATION")}
        subDescription={t("WATER_FOUND_LOCATION_DESC")}
        isNormal={true}
        number={"2.4.2"}
        icon={waterFoundIcon}
      />

      {showTable && (
        <WaterLocationTable
          businessId={businessId}
          category="found"
          subcategory="non_equipment_locational"
        />
      )}
      {showTable && (
        <WaterLocationalEquipmentContents businessId={businessId} />
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default WaterFoundLocationContents;
